module.exports = __webpack_public_path__ + "static/media/stonks.3a866538.jpg";